import React, { useState } from 'react';
import { Button } from 'antd';
import { useTheme } from 'styled-components';

import { useTranslate } from '@/translations';
import {
  faCarBurst,
  faEye,
  faEyeSlash,
  Icon,
  PageContainer,
  Title,
} from '@/ui/components';

import { InspectionsDataGrid } from './components';
import { AppUserTypes } from '@/types';
import { useAppCustomers } from '@/hooks';

export const Inspections = () => {
  const { t } = useTranslate();
  const { accent } = useTheme();
  const { userPermissions } = useAppCustomers();
  const showInspectionInsights =
    userPermissions.userType === AppUserTypes.InternalUsers;
  const [insightsHidden, setInsightsHidden] = useState(false);

  return (
    <PageContainer>
      <div className="d-flex align-items-center justify-content-between gap-2">
        <Title title={t('inspectionSearch')} icon={faCarBurst} color={accent} />
        {showInspectionInsights ? (
          <Button onClick={() => setInsightsHidden(!insightsHidden)}>
            {insightsHidden ? t('showInsights') : t('hideInsights')}
            <Icon icon={insightsHidden ? faEye : faEyeSlash} />
          </Button>
        ) : null}
      </div>

      <InspectionsDataGrid insightsHidden={insightsHidden} />
    </PageContainer>
  );
};
